import React from 'react';
import { Clock } from 'lucide-react';

const DEFAULT_COMING_SOON_MESSAGE =
  'This Stream Center feature is not available yet.';

interface ComingSoonPanelProps {
  title?: string;
  message?: string;
}

const ComingSoonPanel: React.FC<ComingSoonPanelProps> = ({
  title = 'Coming next',
  message = DEFAULT_COMING_SOON_MESSAGE,
}) => (
  <div
    className="rounded-lg border border-secondary-700 bg-secondary-800/60 px-4 py-4 text-secondary-300"
    aria-disabled="true"
    data-testid="lsc-coming-soon-panel"
  >
    <div className="flex items-center gap-2 mb-2">
      <Clock className="h-4 w-4 text-primary-400" aria-hidden />
      <h3 className="font-medium text-secondary-200">{title}</h3>
    </div>
    <p className="text-sm">{message}</p>
  </div>
);

export default ComingSoonPanel;
